import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { AlbumCatalogue } from '../../types';

interface Props {
  spine: AlbumCatalogue['spine'];
  value: string | null;
  saving: boolean;
  onSave: (text: string | null) => void;
}

/**
 * ADR-0052: the title on the cover's spine. Its width is the server's estimate
 * from the page count; below the minimum the title doesn't fit and isn't drawn.
 */
export default function AlbumSpineTools({ spine, value, saving, onSave }: Props) {
  const { t } = useTranslation();
  const [text, setText] = useState(value ?? '');
  const fits = spine.width >= spine.minForText;
  const commit = () => {
    const next = text.trim() || null;
    if (next !== (value ?? null)) onSave(next);
  };
  return (
    <section className="space-y-2">
      <h3 className="text-xs font-semibold uppercase tracking-wider text-slate-500">{t('album.spine.title')}</h3>
      <input
        value={text}
        maxLength={spine.maxChars}
        disabled={saving}
        onChange={e => setText(e.target.value)}
        onBlur={commit}
        onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); commit(); } }}
        placeholder={t('album.spine.placeholder')}
        aria-label={t('album.spine.title')}
        className="input w-full text-sm"
      />
      <p className="text-xs text-slate-500 dark:text-slate-400">
        {fits ? t('album.spine.width', { mm: spine.width }) : t('album.spine.tooThin', { mm: spine.width, min: spine.minForText })}
      </p>
    </section>
  );
}
